import { EMPTY_SELECTION, selectRange, setPageSelected, toggleRow, type SelectionState } from '../../../../lib/selection';

// The list's ticks, on the shared selection machine (lib/selection). One difference: "Select all N
// matching" is sent to the server as the filters, which cannot carry exceptions — so unticking
// someone out of it becomes an ordinary selection of the rest of this page, and the count says so.

export function tickRow(selection: SelectionState, id: string, pageIds: readonly string[], isShift: boolean): SelectionState {
  if (selection.mode === 'all-matching') {
    const rest = new Set(pageIds.filter((pageId) => pageId !== id));
    return rest.size === 0 ? EMPTY_SELECTION : { mode: 'some', ids: rest, excluded: new Set(), anchor: id };
  }
  return isShift ? selectRange(selection, id, pageIds) : toggleRow(selection, id);
}

export function tickPage(selection: SelectionState, pageIds: readonly string[], isTicked: boolean): SelectionState {
  if (selection.mode === 'all-matching') return isTicked ? selection : EMPTY_SELECTION;
  return setPageSelected(selection, pageIds, isTicked);
}
